import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"app":"","color":"green","dark":"","padless":"","absolute":""}},[_c(VCol,{staticClass:"text-center text-caption",attrs:{"cols":"12"}},[_vm._v(" © 2010-"+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("SlothNinja")]),_vm._v(". All logos and trademarks are property of their respective owner. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }